import {
  createRequestContract,
  createResponseContract,

  requestVerbs,
  responseTypes,
} from '@bingads-webui-react/overreact';

import { schema } from '../../../environment/schema';
import { getDefaultOptions } from '../../../request-contract-helper/index';

function ccUrlFactory() {
  return 'cc/Account/ValidateAddressAndTax';
}

function ccOptionsFactory() {
  return getDefaultOptions();
}

function ccPayloadFactory(params) {
  const { variables } = params;

  const {
    locator,
    address,
  } = variables;

  const { descriptor } = locator;
  const { uid, cid, aid } = descriptor;

  return {
    uid,
    customerId: cid,
    accountId: aid,
    Account: {
      BusinessAddress: address,
    },
  };
}

export const fetchRequestContract = createRequestContract({
  schema,
  dataPath: 'user:customer:account:validate_address',
  verb: requestVerbs.POST,
  uriFactoryFn: ccUrlFactory,
  headerFactoryFn: ccOptionsFactory,
  payloadFactoryFn: ccPayloadFactory,
  parentKeySelector: variables => variables.locator.descriptor.aid,
});

export const fetchResponseContract = createResponseContract({
  requestContract: fetchRequestContract,
  responseType: responseTypes.ENTITY,
  keySelector: entity => entity.OriginalAddress.BusinessName,
  processorFn: response => response,
});
